import { formatVenueSlugLabel } from '../../helpers/formatVenueSlugLabel'
import type { VenueDTO } from '../../types'
import { includesSearchText } from '../../helpers/includesSearchText'

export function matchesVenueFilters(
  venueId: string,
  venue: Pick<VenueDTO, 'id' | 'venueSlug'> | undefined,
  venueSearch: string,
  venueType: string
): boolean {
  const venueLabel = venue ? formatVenueSlugLabel(venue) : venueId
  if (!includesSearchText(venueLabel, venueSearch)) {
    return false
  }
  const isManual = venue?.venueSlug === venueId
  if (venueType === 'manual') {
    return isManual
  }
  if (venueType === 'ingested') {
    return !isManual
  }
  return true
}
